import Discount from '../service/discount'
import RequestUtils from '../../store/requestUtils'
export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    getseckillgoodslist(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Discount.getseckillgoodslist(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getongoingseckillgoodslist(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Discount.getongoingseckillgoodslist(payload), {
        type: 'list',
        success,
        fail
      })
    },
    getseckillgoods(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Discount.getseckillgoods(payload), {
        type: 'info',
        success,
        fail
      })
    },
    addseckillgoods(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Discount.addseckillgoods(payload), {
        type: 'action',
        success,
        fail
      })
    },
    updateseckillgoods(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Discount.updateseckillgoods(payload), {
        type: 'action',
        success,
        fail
      })
    },
    deleteseckillgoods(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Discount.deleteseckillgoods(payload), {
        type: 'action',
        success,
        fail
      })
    },
    publishseckillgoods(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Discount.publishseckillgoods(payload), {
        type: 'action',
        success,
        fail
      })
    },
    closeseckillgoods(context, { payload, success, fail }) {
      RequestUtils.fetchWrapper(Discount.closeseckillgoods(payload), {
        type: 'action',
        success,
        fail
      })
    }
  }
}
